import { render } from "./common-confirm-delete.vue?vue&type=template&id=068e978d"
import script from "./common-confirm-delete.vue?vue&type=script&lang=js"
export * from "./common-confirm-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__